import Vue from "vue";
import Vuex from "vuex";

import profile from "./modules/profile.module";
import buy from "./modules/buy.module";
import bank from "./modules/bank.module";
import dashboard from "./modules/dashboard.module";
import auth from "./modules/auth.module";
import consignment from "./modules/consignment.module";
import adminconsignment from "./modules/adminconsignment.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    profile,
    dashboard,
    buy,
    bank,
    consignment,
    adminconsignment
  }
});
